// 引用axios
import axios from 'axios'
import { lang } from '@/utils/utility-lang'
import api from '@/utils/api'

const instance = axios.create({
  timeout: 4 * 1000, //请求超时时间（5秒后还未接收到数据，就需要再次发送请求）
  retry: 3, //设置全局重试请求次数（最多重试几次请求）
  retryDelay: 1000 //设置全局请求间隔
})

function reTry(error) {
  // console.log(error.response)
  //超时处理 error.config是一个对象，包含上方create中设置的三个参数
  var config = error.config
  if (!config || !config.retry) return Promise.reject(error)
  // __retryCount用来记录当前是第几次发送请求
  config.__retryCount = config.__retryCount || 0
  // 如果当前发送的请求大于等于设置好的请求次数时，不再发送请求，返回最终的错误信息
  if (config.__retryCount >= config.retry) {
    return Promise.reject(error)
  }
  // 记录请求次数+1
  config.__retryCount += 1
  // 设置请求间隔 在发送下一次请求之前停留一段时间，时间为上方设置好的请求间隔时间
  var backoff = new Promise(function (resolve) {
    setTimeout(function () {
      resolve()
    }, config.retryDelay || 1)
  })
  // 再次发送请求
  return backoff.then(function () {
    return instance(config)
  })
}

// 支持英文版的 f10 接口列表
const supportF10En = {
  us: [
    '/summary/basic',
    '/summary/com-info',
    '/summary/relates-info',
    '/summary/inst-hold-details',
    '/summary/hold-change',
    '/summary/reportdata'
  ],
  hk: [
    '/summary/basic',
    '/summary/com-info',
    '/broker/shareholdingratio',
    '/summary/holders-equity-details',
    '/summary/holders-equity-current',
    '/summary/ca-dividends',
    '/summary/ca-splits',
    '/summary/ca-meeting',
    '/summary/manager',
    '/summary/hold-change',
    '/summary/major-shareholders',
    '/finance/segment',
    '/summary/reportdata'
  ]
}

// 请求拦截器
instance.interceptors.request.use((res) => {
  // 设置语言
  res.headers['Prefer-Language'] = lang

  // 添加 Fiu-Auth 请求头，以供后端接口判断权限进行延时
  if (window.rmToken) {
    res.headers['Fiu-Auth'] = window.rmToken
  }

  res.headers['Authorization'] = instance.RMF10Authorization

  // 当前是英文版，港美的 f10 接口需要拼接 -en 后缀
  if (lang.startsWith('en')) {
    const isHkF10 = res.url.startsWith(api.f10.hk)
    const isUsF10 = res.url.startsWith(api.f10.us)

    let market = ''
    let url = ''
    if (isHkF10) {
      market = 'hk'
      url = res.url.replace(api.f10.hk, '')
    } else if (isUsF10) {
      market = 'us'
      url = res.url.replace(api.f10.us, '')
    }

    const supportEnList = supportF10En[market] ?? []

    if (supportEnList.some((item) => res.url.endsWith(item))) {
      res.headers['Authorization'] = instance.F10Authorization

      // 英文版替换为特殊的请求路径
      res.url = `https://globaldata.szfuit.com/api/${market}/f10${url}-en`
    }
  }

  return res
})

// 响应拦截器
instance.interceptors.response.use((res) => {
  if (res.status !== 200 || (res.data.code && !['200', '0', 200, 0].includes(res.data.code))) {
    return reTry(res)
  }
  return Promise.resolve(res)
}, reTry)

export function setSDKAuth(auth) {
  instance.defaults.headers.token = auth
}

// 设置旧版 f10 接口鉴权（英文版接口需要）
export function setF10Auth(auth) {
  instance.F10Authorization = 'Bearer ' + auth
}

// 设置 融脉 f10 接口鉴权
export function setRMF10Auth(auth) {
  instance.RMF10Authorization = 'Basic ' + auth
}

export function get(url, data = {}, config) {
  return new Promise((resolve) => {
    instance.get(url, data, config).then(
      (response) => resolve(response.data),
      () => resolve({})
    )
  })
}

export function post(url, data = {}, config) {
  return new Promise((resolve) => {
    instance.post(url, data, config).then(
      (response) => {
        // console.log('response', response)
        resolve(response.data)
      },
      () => {
        // console.log('err++', err.response)
        resolve({})
      }
    )
  })
}
